<template>
    <div>
        <content-view v-show="$utils.renderWhen(this,'newStorageIndex')">
            <!-- 仓库管理 -->
            <div slot="header">
                <!-- 金蝶 -->
                <a-form :form="kingDiskFilterForm" layout="inline" class="store-one-form" v-show="currentKey === 0">
                    <a-form-item label="仓库编号">
                        <a-input style="width:100%;" placeholder="请输入" v-decorator="['warehouseNo']" @pressEnter="kingDiskSearch"></a-input>
                    </a-form-item>
                    <a-form-item label="仓库名称">
                        <a-input placeholder="请输入" v-decorator="['warehouseName']" @pressEnter="kingDiskSearch"></a-input>
                    </a-form-item>
                    <a-form-item label="仓库属性">
                        <a-select placeholder="请选择" v-decorator="['warehouseProperty']" @select="kingDiskSearch">
                            <a-select-option :value='1'>普通仓库</a-select-option>
                            <a-select-option :value='2'>车间仓库</a-select-option>
                            <a-select-option :value='3'>供应商仓库</a-select-option>
                            <a-select-option :value='4'>客户仓库</a-select-option>
                            <a-select-option :value='5'>第三方仓储</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="库存状态">
                        <a-select placeholder="请选择" v-decorator="['warehouseStatus']" @select="kingDiskSearch">
                            <a-select-option :value='0'>可用</a-select-option>
                            <a-select-option :value='1'>待检</a-select-option>
                            <a-select-option :value='2'>冻结</a-select-option>
                            <a-select-option :value='3'>退回冻结</a-select-option>
                            <a-select-option :value='4'>在途</a-select-option>
                            <a-select-option :value='5'>收货冻结</a-select-option>
                            <a-select-option :value='6'>废品</a-select-option>
                            <a-select-option :value='7'>不良</a-select-option>
                            <a-select-option :value='8'>不参与核算</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button type="primary" @click="kingDiskSearch" :loading="kingDiskSearchLoading">筛选</a-button>
                        <a-button @click="kingDiskHandleReset()" :loading="kingDiskSearchLoading">重置</a-button>
                    </a-form-item>
                </a-form>
                <!-- 自有 -->
                <a-form :form="selfFilterForm" layout="inline" class="store-one-form" v-show="currentKey === 1">
                    <a-form-item label="仓库编号">
                        <a-input style="width:100%;" placeholder="请输入" v-decorator="['warehouseNo']"></a-input>
                    </a-form-item>
                    <a-form-item label="仓库名称">
                        <a-input placeholder="请输入" v-decorator="['warehouseName']"></a-input>
                    </a-form-item>
                    <a-form-item label="仓库级别">
                        <a-select placeholder="请选择" v-decorator="['warehouseLevel']">
                            <a-select-option :value='1'>一级仓库</a-select-option>
                            <a-select-option :value='2'>二级仓库</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="仓库类型">
                        <a-select :options="selfWarehouseTypeOptions" placeholder="请选择" v-decorator="['warehouseTypeName']"></a-select>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button type="primary" @click="selfSearch" :loading="selfSearchLoading">筛选</a-button>
                        <a-button @click="selfHandleReset()" :loading="selfSearchLoading">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-tabs type="card" class="tabs-bar-no-margin" v-model="currentKey">
                <template slot="tabBarExtraContent">
                    <a-button v-if="currentKey === 0" type="primary" @click="kingDiskRefresh" :loading="kingDiskRefreshLoading">数据刷新</a-button>
                    <template v-if="currentKey === 1">
                        <a-button v-if="getBtnByAuth('newStorageWarehouseAddButton') && selfIsUse" type="primary" @click="showAddOrEditRow(null)">新增仓库</a-button>
                        <a-button v-else :disabled="true">新增仓库</a-button>
                    </template>
                </template>
                <a-tab-pane :key="0" >
                    <template slot="tab">
                        金蝶-仓库数据 
                        {{kingDiskIsUse ? '（使用中）' : '（停用中）'}}
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span>每天00：00系统自动刷新数据，与金蝶系统数据进行对比同步</span>
                            </template>
                            <span class="text-primary">
                                <a-icon type="exclamation-circle" theme="filled" />
                            </span>
                        </a-tooltip>
                    </template>
                    <div class="wrap-container-in">
                        <div class="mb16" v-if="Number(shopId) === -1">
                            <span class="text-primary">当前所取金蝶系统机构为：{{shopBinding.organizationName || '请先选择切换并绑定机构！'}}</span>
                            <a class="ml16" @click="showSwitchOrganization">切换机构</a>
                        </div>
                        <a-table
                        bordered
                        :columns="kingDiskColumns"
                        :dataSource="kingDiskWarehouseList"
                        :pagination="kingDiskPagination"
                        :rowKey="record => record.id"
                        @change="kingDiskChangePage"
                        :loading="kingDiskTableLoading"
                        class="wrap-table"
                        >
                        <template slot="action" slot-scope="a,row">
                            <a v-if="getBtnByAuth('newStorageWarehouseDetailButton')" class="text-primary" @click="toStorageDetail(row)">查看详情</a>
                            <span v-else class="text-disabled">查看详情</span>
                        </template>
                        </a-table>
                    </div>
                </a-tab-pane>
                <!-- <a-tab-pane :key="1">
                    <template slot="tab">
                        系统自有-仓库数据
                        {{selfIsUse ? '（使用中）' : '（停用中）'}}
                    </template>
                    <div class="wrap-container-in">
                        <a-table
                        bordered
                        :columns="selfColumns"
                        :dataSource="selfWarehouseList"
                        :pagination="selfPagination"
                        :rowKey="record => record.id"
                        @change="selfChangePage"
                        :loading="selfTableLoading"
                        class="wrap-table"
                        >
                            <template slot="warehouseLevel" slot-scope="warehouseLevel">
                                <span>{{['','一级仓库','二级仓库'][warehouseLevel]}}</span>
                            </template>
                            <template slot="action" slot-scope="a,row">
                                <template v-if="getBtnByAuth('newStorageWarehouseEditButton')">
                                    <a v-if="row.warehouseLevel !== 1" class="text-primary" @click="showAddOrEditRow(row)">编辑</a>
                                    <span v-else class="text-disabled">编辑</span>
                                </template>
                                <span v-else class="text-disabled">编辑</span>
                                <a-divider type="vertical"/>
                                <a v-if="getBtnByAuth('newStorageStoreDetailButton')" class="text-primary" @click="toWareHouse(row)">仓库存储</a>
                                <span v-else class="text-disabled">仓库存储</span>
                                <a-divider type="vertical"/>
                                <template v-if="getBtnByAuth('newStorageWarehouseDeleteButton')">
                                    <a-popconfirm
                                        v-if="row.warehouseLevel != 1"
                                        :title="`确定删除“${row.warehouseName}”吗？`"
                                        @confirm="delectWarehouseList(row.id)"
                                    >
                                        <a class="text-primary">删除</a>
                                    </a-popconfirm>
                                    <span v-else class="text-disabled">删除</span>
                                </template>
                                <span v-else class="text-disabled">删除</span>
                            </template>
                        </a-table>
                    </div>
                </a-tab-pane> -->
            </a-tabs>
            <!-- 添加和编辑弹窗 -->
            <a-modal
            :title="storageTitle"
            :visible="visibleAddOrEditStorage"
            centered
            @cancel="visibleAddOrEditStorage = false"
            :destroyOnClose="true"
            :maskClosable="false"
            >
                <a-form :form="addOrEditStorageForm" :selfUpdate="true">
                    <a-form-item label="仓库名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
                        <a-input
                            placeholder="请输入"
                            v-decorator="['warehouseName', {rules: [{ required: true, message: '请输入仓库名称' }, {max: 20, message: '不能超过20个字'}, {whitespace: true, message: '仓库名称不能为空字符'}]}]"
                            style="width: 280px;"
                        />
                    </a-form-item>
                    <a-form-item label="仓库类型" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
                        <a-select
                            :options="selfWarehouseTypeOptions"
                            v-decorator="['warehouseTypeId',{rules: [{ required: true, message: '请选择仓库类型'}]}]"
                            placeholder="请选择"
                            style="width: 280px;"
                        >
                        </a-select>
                        <a class="ml16" @click="visibleEditStorageType = true">类型管理</a>
                    </a-form-item>
                </a-form>
                <template slot="footer">
                    <a-button @click="visibleAddOrEditStorage = false">取消</a-button>
                    <a-button v-if="isAddWarehouse" type="primary" @click="warehouseAdd" :loading="addOrEditStorageLoding">确定</a-button>
                    <a-button v-else type="primary" @click="warehouseUpdate" :loading="addOrEditStorageLoding">确定</a-button>
                </template>
            </a-modal>
            <!-- 分类编辑 -->
            <a-modal
            title="仓库类型管理"
            :visible="visibleEditStorageType"
            centered
            @cancel="visibleEditStorageType = false"
            :destroyOnClose="true"
            :maskClosable="false"
            >
                <a-form :form="editStoreTypeForm" :selfUpdate="true">
                    <a-spin :spinning="getSelfWarehouseTypeListLoading">
                        <a-form-item label="当前已有仓库类型" class="no-margin_bottom">
                            <template v-for="item in selfWarehouseTypeOptions">
                                <a-tag :key="item.id">
                                    {{item.warehouseTypeName}}
                                    <a-divider type="vertical"></a-divider>
                                    <a-popconfirm placement="top" ok-text="确认" cancel-text="取消" @confirm="selfWarehouseDelType(item.id)">
                                        <template slot="title">
                                            确认要删此类型吗？
                                        </template>
                                        <a-icon class="text-fail" theme="filled" type="close-circle" />
                                    </a-popconfirm>
                                </a-tag>
                            </template>
                        </a-form-item>
                    </a-spin>
                    <a-divider></a-divider>
                    <a-form-item label="新增仓库类型" class="no-margin_bottom">
                        <a-input
                            placeholder="请输入仓库类型名称"
                            v-decorator="['warehouseTypeName', {rules: [{ required: true, message: '请输入仓库类型名称' }, {max: 20, message: '不能超过20个字'}, {whitespace: true, message: '仓库类型名称不能为空字符'}]}]"
                            style="width: 280px;"
                        />
                        <a-button type="primary" class="ml8" @click="selfWarehouseAddType" :loading="selfWarehouseAddTypeLoading">确认</a-button>
                    </a-form-item>
                </a-form>
                <template slot="footer">
                    <div class="text-center">
                        <a-button @click="visibleEditStorageType = false">返回</a-button>
                    </div>
                </template>
            </a-modal>
            <a-modal
            centered
            title="切换确认"
            :width="500"
            :visible="visibleSwitchComfirm"
            @ok="switchOrganizationOk"
            @cancel="switchOrganizationCancel"
            :confirmLoading="switchOrganizationLoading"
            :destroyOnClose="true"
            :maskClosable="false"
            >
                <a-form :form="switchOrganizationForm" layout="inline">
                    <div class="mb16 text-primary">
                        当前所取金蝶系统机构为：{{shopBinding.organizationName}}
                    </div>
                    <a-form-item label="请选择金蝶系统对应机构">
                        <a-select 
                        style="width: 250px;" 
                        placeholder="请选择" 
                        :options="kingDiskOrganizationList" 
                        v-decorator="['organizationId', {rules: [{required: true, message: '请选择'}]}]"
                        ></a-select>
                    </a-form-item>
                </a-form>
            </a-modal>
            <a-modal
            centered
            :visible="visibleSyncing"
            :closable="false"
            :maskClosable="false"
            :footer="null"
            :width="300"
            >
                <div class="text-center text-primary">
                    <a-icon type="sync" class="animated rotate360 infinite slow" style="font-size: 36px;" />
                    <div class="mt24">数据刷新中，请稍等...</div>
                </div>
            </a-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    const kingDiskColumns = [
        {
            title: '仓库编号',
            dataIndex: 'warehouseNo',
        },
        {
            title: '仓库名称',
            dataIndex: 'warehouseName'
        },
        {
            title: '仓库属性',
            dataIndex: 'warehousePropertyStr',
        },
        {
            title: '数据状态',
            dataIndex: 'documentStatusStr'
        },
        {
            title: '禁用状态',
            dataIndex: 'forbidStatusStr'
        },
        {
            title: '库存状态',
            dataIndex: 'warehouseStatus'
        },
        {
            title: '操作',
            scopedSlots: {
                customRender: 'action'
            }
        }
    ];
    const selfColumns = [
        {
            title: '仓库编号',
            dataIndex: 'warehouseNo'
        },
        {
            title: '仓库名称',
            dataIndex: 'warehouseName'
        },
        {
            title: '仓库级别',
            dataIndex: 'warehouseLevel',
            scopedSlots: {customRender: 'warehouseLevel'}
        },
        {
            title: '仓库类型',
            dataIndex: 'warehouseTypeName'
        },
        {
            title: '操作',
            scopedSlots: {
                customRender: 'action'
            }
        }
    ]
    export default {
        name: 'storageIndex',
        components: {},
        props: {},
        data() {
            return {
                currentKey: 0,
                //金蝶
                kingDiskColumns,
                kingDiskWarehouseList: [],//金蝶仓库数据
                kingDiskOrganizationList: [],//金蝶机构数据
                shopBinding: {},//获取门店绑定的机构
                kingDiskPagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                kingDiskSearchLoading: false,
                visibleSwitchComfirm: false,
                visibleSwitching: false,
                visibleResult: false,
                kingDiskTableLoading: false,
                switchOrganizationLoading: false,
                kingDiskRefreshLoading: false,
                visibleSyncing: false,
                // 自有
                isAddWarehouse: true,
                warehouseLevelOptions: [],
                selfColumns,
                selfWarehouseList: [],//金蝶仓库数据
                selfPagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                selfSearchLoading: false,
                selfTableLoading: false,
                visibleAddOrEditStorage: false,
                selfWarehouseAddTypeLoading: false,
                getSelfWarehouseTypeListLoading: false,
                selfWarehouseTypeOptions: [],
                addOrEditStorageLoding: false,
                storageTitle: '',
                visibleEditStorageType: false,
                currentActionRow: null,
                kingDiskIsUse: false,
                selfIsUse: false,
            };
        },
        watch: {
            '$route'(val) {
                val.name == 'storageIndex' && this.getKingDiskWarehouseList();
                val.name == 'storageIndex' && this.getSelfWarehouseList();
            },
            'shopId'() {
                this.kingDiskPagination.current = 1;
                this.selfPagination.current = 1;
                this.sysIsUse(0);
                this.sysIsUse(1);
                this.getShopBinding();
                this.getkingDiskOrganization();
                this.getSelfWarehouseTypeList();
                this.getKingDiskWarehouseList();
                this.getSelfWarehouseList();
            }
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            /**
             * @toStorageDetail 跳转仓库详情
             */
            toStorageDetail(row) {
                this.$router.push({name: 'storageDetail', params: {id: row.id}});
            },
            // 金蝶
            kingDiskChangePage(page) {
                this.kingDiskPagination = page;
                this.getKingDiskWarehouseList();
            },
            // 重置筛选
            kingDiskHandleReset() {
                this.kingDiskFilterForm.resetFields();
                this.kingDiskSearch();
            },
            kingDiskSearch() {
                this.kingDiskPagination.current = 1;
                this.getKingDiskWarehouseList();
            },
            /**
             * @getKingDiskWarehouseList 获取金蝶仓库数据
             */
            getKingDiskWarehouseList() {
                if (this.kingDiskSearchLoading) {
                    return false;
                }
                this.kingDiskFilterForm.validateFields((err, values) => {
                    if (err) return;
                    if(!this.shopId) return
                    values.shopId = this.shopId;
                    this.kingDiskSearchLoading = true;
                    this.kingDiskTableLoading = true;
                    this.$api.newStorage.kingDiskWarehousePage({ body: {
                        ...values,
                        pageNum: this.kingDiskPagination.current,
                        pageSize: this.kingDiskPagination.pageSize
                    } }).then(res => {
                        this.kingDiskWarehouseList = res.data;
                        this.kingDiskPagination.total = res.total;
                        this.kingDiskTableLoading = false;
                        this.kingDiskSearchLoading = false;
                    }).catch(res => {
                        this.kingDiskTableLoading = false;
                        this.kingDiskSearchLoading = false;
                    });
                })
            },
            /**
             * @getkingDiskOrganization 获取组织列表
             */
            getkingDiskOrganization() {
                if(!this.shopId) return
                this.$api.newStorage.kingDiskOrganization({}).then(res => {
                    res.forEach(item => {
                        item.value = item.id;
                        item.label = item.organizationName;
                    });
                    this.kingDiskOrganizationList = res;
                });
            },
            /**
             * @getShopBinding 获取门店绑定的机构
             */
            getShopBinding() {
                if(!this.shopId) return
                this.$api.newStorage.shopBinding({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (Boolean(res)) {
                        this.shopBinding = res;
                    }
                });
            },
            /**
             * @kingDiskRefresh 金蝶数据刷新
             */
            kingDiskRefresh() {
                if(!this.shopId) return;
                this.visibleSyncing = true;
                this.kingDiskRefreshLoading = true;
                this.$api.newStorage.warehouseRefresh({
                    body: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    this.kingDiskRefreshLoading = false;
                    this.getKingDiskWarehouseList();
                    this.visibleSyncing = false;
                    this.$message.success('数据刷新成功！', 5);
                }).catch(err => {
                    this.visibleSyncing = false;
                    this.kingDiskRefreshLoading = false;
                });
            },
            /**
             * @showSwitchOrganization 显示切换组织
             */
            showSwitchOrganization() {
                this.visibleSwitchComfirm = true;
            },
            /**
             * @switchOrganizationOk 切换组织确认
             */
            switchOrganizationOk() {
                this.switchOrganizationForm.validateFields((errors, values) => {
                    if (Boolean(errors)) return;
                    this.switchOrganizationLoading = true;
                    this.$api.newStorage.binding({
                        body: {
                            organizationId: values.organizationId,
                            shopId: this.shopId,
                            type: Boolean(this.shopId) === -1 ? 0 : undefined
                        }
                    }).then(res => {
                        this.switchOrganizationLoading = false;
                        this.visibleSwitchComfirm = false;
                        setTimeout(() => {
                            this.getShopBinding();
                            this.getKingDiskWarehouseList();
                        }, 300);
                    }).catch(err => {
                        this.switchOrganizationLoading = false;
                    });
                });
            },
            /**
             * @switchOrganizationCancel 切换组织取消
             */
            switchOrganizationCancel() {
                this.visibleSwitchComfirm = false;
            },
            //自有
            selfChangePage(page) {
                this.selfPagination = page;
                this.getSelfWarehouseList();
            },
            // 重置筛选
            selfHandleReset() {
                this.selfFilterForm.resetFields();
                this.selfSearch();
            },
            selfSearch() {
                this.selfPagination.current = 1;
                this.getSelfWarehouseList();
            },
            /**
             * @getSelfWarehouseList 获取自有仓库数据
             */
            getSelfWarehouseList() {
                if (this.selfSearchLoading) {
                    return false;
                }
                this.selfFilterForm.validateFields((err, values) => {
                    if (err) return;
                    if(!this.shopId) return
                    values.shopId = this.shopId;
                    if (values.warehouseTypeName) {
                        values.warehouseTypeName = this.selfWarehouseTypeOptions.find(item => item.id === values.warehouseTypeName).warehouseTypeName;
                    }
                    this.selfSearchLoading = true;
                    this.selfTableLoading = true;
                    this.$api.newStorage.selfWarehousePage({ body: {
                        ...values,
                        pageNum: this.selfPagination.current,
                        pageSize: this.selfPagination.pageSize
                    } }).then(res => {
                        this.selfWarehouseList = res.data;
                        this.selfPagination.total = res.total;
                        this.selfTableLoading = false;
                        this.selfSearchLoading = false;
                        if (Boolean(values.warehouseNo)|| Boolean(values.warehouseLevel)|| Boolean(values.warehouseName)|| Boolean(values.warehouseTypeName)) {
                            return false;
                        }
                    }).catch(res => {
                        this.selfTableLoading = false;
                        this.selfSearchLoading = false;
                    });
                })
            },
            /**
             * @showAddOrEditRow 显示新增/编辑仓库弹窗
             */
            showAddOrEditRow(row) {
                this.visibleAddOrEditStorage = true;
                if (Boolean(row)) {
                    this.currentActionRow = row;
                    let value = {
                        warehouseName: row.warehouseName,
                        warehouseTypeId: row.warehouseTypeId,
                    }
                    setTimeout(() => {
                        this.addOrEditStorageForm.setFieldsValue(value);
                    }, 300);
                    this.storageTitle = row.warehouseName;
                    this.isAddWarehouse = false;
                } else {
                    this.isAddWarehouse = true;
                    this.storageTitle = '新增仓库';
                }
            },
            /**
             * @warehouseAdd 新增仓库
             */
            warehouseAdd() {
                this.addOrEditStorageForm.validateFields((errors, values) => {
                    if (Boolean(errors)) {
                        return false;
                    }
                    this.addOrEditStorageLoding = true;
                    this.$api.newStorage.warehouseAdd({
                        body: {
                            ...values,
                            shopId: this.shopId,
                            userId: this.userInfo.id,
                            account: this.userInfo.account,
                            username: this.userInfo.name
                        }
                    }).then(res => {
                        this.$message.success('操作成功');
                        this.visibleAddOrEditStorage = false;
                        this.addOrEditStorageLoding = false;
                        setTimeout(() => {
                            this.getSelfWarehouseList();
                        }, 300);
                    }).catch(err => {
                        this.addOrEditStorageLoding = false;
                    });
                });
            },
            /**
             * @warehouseUpdate 编辑仓库
             */
            warehouseUpdate() {
                this.addOrEditStorageForm.validateFields((errors, values) => {
                    if (Boolean(errors)) {
                        return false;
                    }
                    this.addOrEditStorageLoding = true;
                    this.$api.newStorage.selfWarehouseUpdate({
                        body: {
                            ...values,
                            id: this.currentActionRow.id,
                            shopId: this.shopId,
                            userId: this.userInfo.id,
                            account: this.userInfo.account,
                            username: this.userInfo.name
                        }
                    }).then(res => {
                        this.$message.success('操作成功');
                        this.visibleAddOrEditStorage = false;
                        this.addOrEditStorageLoding = false;
                        setTimeout(() => {
                            this.getSelfWarehouseList();
                        }, 300);
                    }).catch(err => {
                        this.addOrEditStorageLoding = false;
                    });
                });
            },
            /**
             * @selfWarehouseAddType 添加仓库类型
             */
            selfWarehouseAddType() {
                this.editStoreTypeForm.validateFields((errors, values) => {
                    if (Boolean(errors)) {
                        return false;
                    }
                    this.selfWarehouseAddTypeLoading = true;
                    this.$api.newStorage.selfWarehouseAddType({
                        body: {
                            shopId: this.shopId,
                            warehouseTypeName: values.warehouseTypeName
                        }
                    }).then(res => {
                        this.selfWarehouseAddTypeLoading = false;
                        this.$message.success('操作成功');
                        this.editStoreTypeForm.resetFields();
                        this.getSelfWarehouseTypeList();
                    }).catch(err => {
                        this.selfWarehouseAddTypeLoading = false;
                    });
                });
            },
            /**
             * @selfWarehouseDelType 删除仓库类型
             */
            selfWarehouseDelType(id) {
                this.getSelfWarehouseTypeListLoading = true;
                this.$api.newStorage.selfWarehouseDelType({
                    query: {
                        id,
                        shopId: this.shopId,
                        userId: this.userInfo.id,
                        account: this.userInfo.account,
                        username: this.userInfo.name
                    }
                }).then(res => {
                    this.getSelfWarehouseTypeListLoading = false;
                    this.addOrEditStorageForm.resetFields(['warehouseTypeId']);
                    this.selfFilterForm.resetFields(['warehouseTypeName']);
                    this.$message.success('操作成功');
                    this.getSelfWarehouseTypeList();
                }).catch(err => {
                    this.getSelfWarehouseTypeListLoading = false;
                });
            },
            /**
             * @getSelfWarehouseTypeList 仓库类型列表
             */
            getSelfWarehouseTypeList() {
                if (!this.shopId) {
                    return false;
                }
                this.getSelfWarehouseTypeListLoading = true;
                this.$api.newStorage.selfWarehouseTypeList({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    this.getSelfWarehouseTypeListLoading = false;
                    res.forEach(item => {
                        item.value = item.id;
                        item.label = item.warehouseTypeName;
                    });
                    this.selfWarehouseTypeOptions = res;
                });
            },
            //跳转到仓库仓储
            toWareHouse(row) {
                this.$router.push({
                    name: 'newStorageSave',
                    params: { id: row.id }
                });
            },
            //删除仓库信息列表
            delectWarehouseList(id) {
                this.$api.newStorage.selfWarehouseDel({
                    query: {
                        id,
                        shopId: this.shopId,
                        userId: this.userInfo.id,
                        account: this.userInfo.account,
                        username: this.userInfo.name
                    }
                }).then(res => {
                    this.$message.success('操作成功');
                    this.getSelfWarehouseList();
                });
            },
            /**
             * @sysIsUse 是否使用该系统
             */
            sysIsUse(systemType) {
                if (!this.shopId) {
                    return false;
                }
                this.$api.newStorage.sysIsUse({
                    query: {
                        shopId: this.shopId,
                        systemType
                    }
                }).then(res => {
                    if (systemType === 0) {
                        this.kingDiskIsUse = Boolean(res.isUse);
                    } else {
                        this.selfIsUse = Boolean(res.isUse);
                    }
                });
            }
        },
        beforeCreate() {
            this.kingDiskFilterForm = this.$form.createForm(this);
            this.selfFilterForm = this.$form.createForm(this);
            this.addOrEditStorageForm = this.$form.createForm(this);
            this.editStoreTypeForm = this.$form.createForm(this);
            this.switchOrganizationForm = this.$form.createForm(this);
            this.userInfo = this.$userInfoTool.getUser();
        },
        created() {},
        mounted() {
            this.sysIsUse(0);
            this.sysIsUse(1);
            this.getShopBinding();
            this.getkingDiskOrganization();
            this.getSelfWarehouseTypeList();
            this.getKingDiskWarehouseList();
            this.getSelfWarehouseList();
        },
    };
</script>
<style lang="scss">
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
.tabs-bar-no-margin {
    .ant-tabs-top-bar {
        margin: 0!important;
    }
}
.delectVisible {
    .delect_tips {
        text-align: center;
        height: 50px;
        font-weight: bold;
        font-size: 20px;
    }
    .delect_btn {
        display: flex;
        justify-content: space-around;
    }
}
</style>
